import { render, staticRenderFns } from "./isSettled.vue?vue&type=template&id=ffa74c8e&scoped=true"
import script from "./isSettled.vue?vue&type=script&lang=js"
export * from "./isSettled.vue?vue&type=script&lang=js"
import style0 from "./isSettled.vue?vue&type=style&index=0&id=ffa74c8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa74c8e",
  null
  
)

export default component.exports